document.addEventListener('DOMContentLoaded', ()=>{

  // Removing the span for Slider Button
  setTimeout(()=>{
    
    const btns = document.querySelectorAll('.flickitybee-button')
    if(btns){
      btns.forEach((btn, index)=>{
      console.log('btns', btn)
          btn.style.left = !index ? `calc(50% - 25px)` : `calc(50% + 25px)`;
          btn.classList.add('slider-custom-btn');
          // btn.children[1].style.display = 'none';
      })
  }
  },1000)

  // Insta grid
  const container = document.getElementById('custom-insta-grid')
  if(container){
    const products = container.querySelectorAll('.bee-product-info')
    products.forEach(product=>{
        product.style.display = 'none'
    })
  }

  // Product Page
  const infoContainer = document.querySelector('.bee-product__info-container')
  if(infoContainer){
    const tabContainer = document.querySelector('.bee-product-tabs-wrapper') 
    infoContainer.appendChild(tabContainer)
  }

  const prevnextBreadcrumb = document.querySelector('.breadcrumb_pr_wrap')
  if(prevnextBreadcrumb){
      prevnextBreadcrumb.style.display = 'none'
  }
})